import React from "react";
import { Typography, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { BasicInsuranceDetails } from "../../../interfaces/DTO/mislaka_xml_insurence_models";
import { formatCurrency } from "../../../utils/namesFormater";

interface Props {
  insuranceDetails: BasicInsuranceDetails;
}

export const InsuranceComponent: React.FC<Props> = ({ insuranceDetails }) => {
  const renderCapInfo = (value: number) => (
    <Box display="flex" alignItems="center" gap={1}>
      {value > 0 ? <CheckIcon color="success" /> : <CloseIcon color="error" />}
      <Typography>{value}</Typography>
    </Box>
  );

  return (
    <Box p={2} border={1} borderRadius={2} borderColor="grey.400">
      <Typography variant="h6">{formatCurrency(insuranceDetails.insurance_amount)}</Typography>
      <Box display="flex" flexDirection="column" gap={1} mt={2}>
        <Typography variant="subtitle1">תקרת גג פטירה:</Typography>
        {renderCapInfo(insuranceDetails.death_cap_ceiling)}
        <Typography variant="subtitle1">תקרת גג נכות:</Typography>
        {renderCapInfo(insuranceDetails.disability_cap_ceiling)}
      </Box>
    </Box>
  );
};
